<template>
  <div>
    <breadcrumbs home="Reports">
      <search v-model="search" placeholder="Search for reports"/>
    </breadcrumbs>

    <v-card flat height="calc(100vh - 106px)" class="overflow-y pb-4">
      <v-container fluid>
        <v-row>
          <v-card v-for="(category,c) in reportsToShow" class="mt-4 ml-4" :width="($vuetify.breakpoint.width-($store.state.drawer?256:0)-60)/2">
            <v-card-title :key="c">{{category.category}}</v-card-title>
              <v-list>
                <v-list-item v-for="(report,r) in category.reports" :key="r" :to="{name:'ReportsView',query:{to:report.to}}">
                  <v-list-item-content>
                    <v-list-item-title class="body-2">{{report.name}}</v-list-item-title>
                    <v-list-item-subtitle class="text-caption">{{report.description}}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon>
                      <v-icon :color="report.favourite ? 'green' : 'grey'" @click.prevent="report.favourite=!report.favourite;saveSettings(report)">
                        {{report.favourite ? 'mdi-star' : 'mdi-star-outline'}}
                      </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
          </v-card>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import reports from '@/mixins/reports'

export default {
  name: 'Reports',
  mixins: [reports],
  data() {
    return {
      search: '',
      settings: {}
    }
  },
  computed: {
    favourites() {
      const list = [];
      for (const category of this.reports)
        for (const report of category.reports)
          if (report.favourite)
            list.push(report);
      return list;
    },
    reportsToShow() {
      const categories = [];
      const searchFor = this.search?.toLowerCase();
      const reportsToShow = [{category:'Favourites',reports:this.favourites},...this.reports];
      for (const category of reportsToShow) {
        const reports = [];
        for (const report of category.reports) {
          if (!searchFor || report.name.toLowerCase().includes(searchFor) || report.description.toLowerCase().includes(searchFor))
            reports.push(report);
        }
        if (reports.length)
          categories.push({category:category.category,reports});
      }
      return categories;
    }
  },
  async created() {
    this.$store.dispatch('checkTasks');
    try {
      const reports = await import(`@/views/provinces/${this.$store.getters.company.province}/reports/reports.js`);
      this.reports.splice(1,0,reports.reports);
    // eslint-disable-next-line no-empty
    } catch (error) {
    }

    this.settings = this.$store.getters.userSettings;
    if (!this.settings.reportSettings)
      this.settings.reportSettings = [];
    for (const category of this.reports)
      for (const report of category.reports)
        report.favourite = this.settings.reportSettings.some(s => s === report.to);
  },
  methods: {
    async saveSettings(report) {
      if (report.favourite)
        this.settings.reportSettings.push(report.to);
      else {
        const index = this.settings.reportSettings.findIndex(s => s === report.to);
        this.settings.reportSettings.splice(index, 1);
      }
      this.$store.commit('setUserSettings', this.settings);
    }
  }
}
</script>